import { render, staticRenderFns } from "./simpleDetail.vue?vue&type=template&id=68f920fe&scoped=true&"
import script from "./simpleDetail.vue?vue&type=script&lang=js&"
export * from "./simpleDetail.vue?vue&type=script&lang=js&"
import style0 from "./simpleDetail.vue?vue&type=style&index=0&id=68f920fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f920fe",
  null
  
)

export default component.exports